import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ManutencaoCTEService } from 'src/app/services/gestao-de-cte/gestao-de-cte.service';
import { GestaoDeCteComponent } from '../../gestao-de-cte.component';


@Component({
  selector: 'app-modal-tabela-preco',
  templateUrl: './modal-tabela-preco.component.html',
  styleUrls: ['./modal-tabela-preco.component.scss']
})
export class ModalTabelaPrecoComponent implements OnInit {
  @Input() parent: GestaoDeCteComponent;
  @Input() dados;

  @Input() idTabela;
  @Input() cepOrigem;
  @Input() cepDestino;

  @Input() isModal = false;

  isLoading: boolean = false;
  isLoadingDownload: boolean = false;

  public grid: MatTableDataSource<any> = new MatTableDataSource<any>();
  public displayedColumns: string[] = ['pid', 'origem', 'destino', 'regiao', 'valorFrete', 'taxaAdValorem', 'taxaGris'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialogRef<ModalTabelaPrecoComponent>,
    public snackBar: MatSnackBar,
    public service: ManutencaoCTEService
  ) {
    if (data) {
      this.idTabela = data.idTabela;
      this.cepOrigem = data.cepOrigem;
      this.cepDestino = data.cepDestino;
      this.isModal = data.isModal;
    }
  }

  ngOnInit() {
    this.buscarDadosTabelaPreço();
  }

  public async buscarDadosTabelaPreço(){
    return this.service
      .preLoteTabelaPreco(this.idTabela, this.cepOrigem, this.cepDestino)
      .toPromise()
      .then(
        (response: any) => {
          this.grid.data = response;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar(
            "Erro ao carregar informações da Tabela Preço, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  
  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
